import React from "react";

const ChatLoader = () => {
  return (
    <div className="flex gap-1 items-end">
      <p className="text-base text-blue-500">Thinking</p>
      <div className="flex space-x-1 mb-1">
        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce"></div>
        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce200"></div>
        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce400"></div>
      </div>
    </div>
  );
};

export default ChatLoader;
